import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { LorryService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./addEditlorry.html",
})
export class AddEditLorryInvoice implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  mode = "Add";
  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  @Input() invdata: any = { lr_id: "" };

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    if (this.mode == "Edit") {
      let invdata = Object.assign({}, val["data"]);
      delete invdata["invdet"];

      this.invdata = invdata;
      this.invdata["invdt"] = new Date(
        ("" + this.invdata["invoice_date"]).replace(
          /(\d{2})-(\d{2})-(\d{4})/,
          "$2/$1/$3"
        )
      );
      this.getLrDesignList(this.invdata["lr_id"]);
      this.loadLrnoList(this.invdata.transport);
    }
  }

  get params(): any[] {
    return this._params;
  }

  lrnoList: any = [];
  lrDetList: any = [];

  lrList = [
    {
      lr_no: "",
      inv_id: "",
      Plr_id: "",
      invoice_no: "",
      party_id: "",
      party_name: "",
      pvt_mark: 0,
      no_of_bales: 0,
      lr_amount: 0,
      tds_amount: 0,
      net_amount: 0,
      rec_no: "",
      rec_date: "",
      act_wt: "",
      chr_wt: "",
    },
  ];
  transportList: any = [];
  itemCtrl: FormControl;
  //  rateCtrl: FormControl = new FormControl();
  isLoading: boolean = false;
  @ViewChild("itemForm") itemForm;
  @ViewChild("lorryAuto") lorryAuto;
  @ViewChild("transAuto") transAuto;
  invCtrl: FormControl = new FormControl();
  shipCtrl: FormControl = new FormControl();
  invoicelist: any;
  // companyInfo : any = [];
  //  uomCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private lrService: LorryService,
    public toasterService: ToasterService
  ) {
    // this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
  }

  ngOnInit() {
    if (this.mode == "Add") {
      this.invdata.lr_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
    }
    this.tableScroll();
    this.transportlist();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#transport").focus();
    }, 100);
  }

  tableScroll() {
    $(".lrbody").height(window.innerHeight - 350);
    $(".lrbody").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string): void {
    $("#" + this.page_id + nextEl).focus();

    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design = this.lrList[ind]["design_no"],
      qtyval = this.lrList[ind]["qty"],
      amount = this.lrList[ind]["amt"],
      gst = this.lrList[ind]["gst"],
      gstamt = this.lrList[ind]["gstamt"],
      qty = this.lrList[ind]["qty"],
      rateval = this.lrList[ind]["rate"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "lr_no" && nxtRow.length == 0) {
      let len = this.lrList.length;

      this.lrList.push({
        lr_no: "",
        inv_id: "",
        Plr_id: "",
        invoice_no: "",
        party_id: "",
        party_name: "",
        pvt_mark: 0,
        no_of_bales: 0,
        lr_amount: 0,
        tds_amount: 0,
        net_amount: 0,
        rec_no: "",
        rec_date: "",
        act_wt: "",
        chr_wt: "",
      });
      $("#" + this.page_id + "lr_no").focus();
    }
    nxtInd = this.lrList.length - 1;
    setTimeout(() => {
      $("#" + this.page_id + fld + "-" + nxtInd).focus();
    }, 100);
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onGoToRightAndLeft($event, fld, arrow, ind) {
    if (arrow == "Right") {
    }
    if (arrow == "Left") {
    }

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }
  onkeydown($event, arrow, ind, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if (arrow == "up") {
      ind--;
    } else {
      ind++;
    }
    if (ind < 0) {
      $("#" + this.page_id + "discount").focus();
    } else if (ind < 0) {
      $("#" + this.page_id + "item-0").focus();
    }

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onupanddown($event, fld, arrow) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") {
      if (fld == "item") {
        $("#" + this.page_id + "item-0").focus();
      } else {
        $("#" + this.page_id + "discount").focus();
      }
    } else {
      if (fld == "gstamnt") {
        $("#" + this.page_id + "gstamnt").focus();
      } else if (fld == "gstper") {
        $("#" + this.page_id + "gstper").focus();
      } else {
        $("#" + this.page_id + "amnt-0").focus();
      }
    }
  }

  getLrDesignList(lr_id) {
    let params = {
      lr_id: lr_id,
    };
    this.lrService.getLrDesignList(params).then((res: any) => {
      this.lrList = res.data;
    });
  }

  getAuto() {
    this.lrService.getRefAuto({}).then((res: any) => {
      if (this.mode == "Add") {
        this.invdata.ref_no = res;
      }
    });
  }

  transportlist() {
    this.lrService.transportlist({}).then((res: any) => {
      this.transportList = res.data;
      this.transportList = this.transportList.filter(el => el.transport != '');
    });
  }

  loadLrnoList(name) {
    for (let i = 0; i < this.lrList.length; i++) {
      this.lrList[i]["lr_no"] = "";
      this.lrList[i]["inv_id"] = "";
      this.lrList[i]["Plr_id"] = "";
      this.lrList[i]["invoice_no"] = "";
      this.lrList[i]["party_id"] = "";
      this.lrList[i]["party_name"] = "";
      this.lrList[i]["pvt_mark"] = 0;
      this.lrList[i]["no_of_bales"] = 0;
      this.lrList[i]["lr_amount"] = 0;
      this.lrList[i]["tds_amount"] = 0;
      this.lrList[i]["net_amount"] = 0;
      this.lrList[i]["rec_no"] = "";
      this.lrList[i]["rec_date"] = "";
    }
    this.lrList.splice(1, this.lrList.length);

    let params = {
      transport: name,
    };
    this.lrService.getLRnoList(params).then((res: any) => {
      this.lrnoList = res.data;
      /*  for(let i=0;i<this.lrList.length;i++){
                    this.lrList[i]['lr_no']='';
                    this.lrList[i]['inv_id']='';
                    this.lrList[i]['Plr_id']='';
                    this.lrList[i]['invoice_no']='';
                    this.lrList[i]['party_id']='';
                    this.lrList[i]['party_name']='';
                    this.lrList[i]['pvt_mark']=0;
                    this.lrList[i]['no_of_bales']=0;
                    this.lrList[i]['lr_amount']=0;
                    this.lrList[i]['tds_amount']=0;
                    this.lrList[i]['net_amount']=0;
                    this.lrList[i]['rec_no']='';
                    this.lrList[i]['rec_date']='';
                }*/
    });
  }

  onenterParty(party_name, ind) {
    let params = {
      party_name: party_name,
    };
    this.lrService.getPartyDet(params).then((res: any) => {
      this.lrList[ind].party_id = res.data.party_id;
    });
  }

  onenterInvNo(invno, lrno, ind) {
    let params = {
      invno: invno,
      Plr_id: lrno,
    };
    this.lrService.getLorryDet(params).then((res: any) => {
      this.lrList[ind].party_name = res.data[0].party_name;
      this.lrList[ind].Plr_id = res.data[0].Plr_id;
      this.lrList[ind].inv_id = res.data[0].inv_id;
      this.lrList[ind].pvt_mark = res.data[0].pvt_mark;
      this.lrList[ind].no_of_bales = res.data[0].no_of_bales;
      this.lrList[ind].lr_amount = res.data[0].lr_amount;
      this.lrList[ind].tds_amount = 0.02 * res.data[0].lr_amount;
      this.lrList[ind].net_amount =
        this.lrList[0].lr_amount - this.lrList[0].tds_amount;

      $("#" + this.page_id + "recno").focus();
    });
  }

  loadLrdetails() {
    let params = {};
    this.lrService.getLRDetails(params).then((res: any) => {
      this.invdata = res.data;
    });
  }

  changedateFormat(date, ind) {
    this.lrList[ind].rec_date = this.datePipe.transform(date, "yyyy-MM-dd");
  }

  onselecttransport(trans) {
    this.loadLrnoList(trans);
  }

  onselectlrno($event, ind) {
    this.lrList[ind].Plr_id = $event.item.plr_id;
    let invList = _.filter(this.lrnoList, { lr_no: $event.item.lr_no });
    this.invoicelist = invList;
    //this.invdata.Plr_id = id;
  }

  oncheckemptyrow() {
    let design = this.lrList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].lr_no != "") {
        desList.push(design[i]);
      }
    }
    this.lrList = desList;
    this.onSaveLrDetails();
  }

  onClickInv(inv, ind) {
    let list = _.filter(this.invoicelist, {
      invoice_no: inv,
      plr_id: this.lrList[ind].Plr_id,
    });
    this.lrList[ind].party_name = list[0]["party_code"];
    this.lrList[ind].pvt_mark = list[0]["pvt_mark"];
    this.lrList[ind].no_of_bales = list[0]["no_of_bales"];
    this.lrList[ind].lr_amount = list[0]["lr_amount"];
    this.lrList[ind].tds_amount = (list[0]["lr_amount"] * 2) / 100;
    this.lrList[ind].net_amount =
      list[0]["lr_amount"] - this.lrList[ind].tds_amount;
    this.lrList[ind].inv_id = list[0]["inv_id"];
    this.lrList[ind].party_id = list[0]["party_id"];
    this.lrList[ind].act_wt = list[0]["act_wt"];
    this.lrList[ind].chr_wt = list[0]["chr_wt"];
  }

  onSaveLrDetails(): void {
    let params: any = Object.assign({}, this.invdata);
    params["lrList"] = JSON.stringify(this.lrList);
    params["tabevent"] = undefined;
    params["lr_date"] = this.datePipe.transform(
      params["lr_date"],
      "yyyy-MM-dd"
    );
    let that = this;

    swal({
      title: "Are you sure to save this Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.lrService
        .savelorryDetails(params)
        .then(function (res: any) {
          that.isLoading = false;

          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/lorryDetails/addEditlorry.ts